import classnames from 'classnames';
import { kebabCase } from 'lodash';
import { ELSInlineLoader } from '@els/els-ui-common-react';
import { ELSIcon, ELSIconV2 } from 'components/common';
import InfoIcon from 'components/common/info-icon/InfoIcon';
import ReportPieChart, { ChartType } from 'components/report-pie-chart/ReportPieChart';
var ReportInsightCard = function (_a) {
    var id = _a.id, icon = _a.icon, iconSize = _a.iconSize, customIcon = _a.customIcon, title = _a.title, showTitleInfoIcon = _a.showTitleInfoIcon, subtitle = _a.subtitle, customSubTitle = _a.customSubTitle, isLoading = _a.isLoading, hideChart = _a.hideChart, value = _a.value, valueUnit = _a.valueUnit, total = _a.total, customValueElement = _a.customValueElement, clickable = _a.clickable, chartConfig = _a.chartConfig, onSubTitleClick = _a.onSubTitleClick, customClass = _a.customClass, mainAriaLabel = _a.mainAriaLabel, footerAriaLabel = _a.footerAriaLabel, customFooter = _a.customFooter, isUseBigFontSize = _a.isUseBigFontSize, footerOnly = _a.footerOnly, hideTitle = _a.hideTitle, hideIcon = _a.hideIcon, hideFooter = _a.hideFooter, _b = _a.valueFontSizeClass, valueFontSizeClass = _b === void 0 ? 'u-els-font-size-h2' : _b, _c = _a.dashboard, dashboard = _c === void 0 ? 'cw' : _c;
    var clickSubTitle = function () {
        if (clickable) {
            onSubTitleClick(id);
        }
    };
    var chart = chartConfig && (<div className={classnames(
        // top margin spaces the chart from the title above it in the stacked layout; when the chart sits
        // inline beside the value instead, that margin has no title above it to clear and just misaligns the icon
        { 'u-els-margin-top-1x': chartConfig.type !== ChartType.FULL && !chartConfig.isUseChartInLineWithValue }, { 'u-els-margin-bottom-1x': chartConfig.type === ChartType.FULL }, 'c-report-insight-card__chart')} aria-hidden="true" role="presentation">
      <ReportPieChart key={"chart-".concat(id)} {...chartConfig}/>
    </div>);
    var displayValue = customValueElement || (<>
      <span className="u-els-bold c-report-insight-card__value-data">{value || 0}</span>
      <span> of </span>
      <span className="c-report-insight-card__total-data">{total || 0}</span>
      {valueUnit && <span>{" ".concat(valueUnit)}</span>}
    </>);
    var displaySubTitle = customSubTitle || (<>
      <span className="u-els-margin-right-1o4 c-report-insight-card__subtitle-display">{subtitle}</span>
      <ELSIcon name="chevron-right" size="1x" customClass="o-els-icon-svg o-els-icon-svg--middle o-els-icon-svg--font-offset c-report-insight-card__subtitle-icon"/>
    </>);
    var footer = customFooter ||
        (clickable ? (<button type="button" onClick={clickSubTitle} className="c-report-insight-card__subtitle c-report-insight-card__subtitle--clickable" aria-label={footerAriaLabel}>
        {displaySubTitle}
      </button>) : (<div className="c-report-insight-card__subtitle c-report-insight-card__subtitle--disabled" aria-label={footerAriaLabel}>
        {displaySubTitle}
      </div>));
    var renderBody = function () {
        return footerOnly ? null : (<div className={classnames({ 'c-report-insight-card__without_chart': hideChart }, 'c-report-insight-card__data-visualize')}>
        {!hideChart && !(chartConfig === null || chartConfig === void 0 ? void 0 : chartConfig.isUseChartInLineWithValue) && chart}
        <div className="c-report-insight-card__title-wrapper u-els-margin-top-1o2">
          {!hideTitle && (<div className="u-els-display-flex o-els-flex-layout--middle u-els-margin-bottom-1o2 c-report-insight-card__title">
              {!hideIcon &&
                    (customIcon ? (<span aria-hidden="true">{customIcon}</span>) : (<ELSIconV2 sprite={icon} size={iconSize || isUseBigFontSize ? 's' : 'xs'} textAlignment="offset" aria-hidden="true"/>))}
              <h4 className={classnames({ 'u-els-margin-left-1o2': !hideIcon }, { 'u-els-margin-left-3o4': isUseBigFontSize && !hideIcon }, { 'u-els-font-size-h4': isUseBigFontSize }, 'c-report-insight-card__title')}>
                {title}
              </h4>
              {showTitleInfoIcon && (<InfoIcon dashboard={dashboard} id={kebabCase(id)} customClassName="u-els-margin-left-1o4 u-els-margin-right-1o4 u-els-margin-top-none u-els-line-height-single"/>)}
            </div>)}
          <div className="c-report-insight-card__value-wrapper">
            {!hideChart && (chartConfig === null || chartConfig === void 0 ? void 0 : chartConfig.isUseChartInLineWithValue) && chart}
            <div className={classnames('u-els-margin-bottom-1o4 c-report-insight-card__value', valueFontSizeClass)}>{displayValue}</div>
          </div>
        </div>
      </div>);
    };
    return (<section className={"u-els-background-color-white c-report-insight-card ".concat(customClass || '')} tabIndex={-1} aria-label={mainAriaLabel}>
      {isLoading ? (<div className="u-els-display-flex c-report-insight-card__loader">
          <ELSInlineLoader />
        </div>) : (<>
          {renderBody()}
          {!hideFooter && footer}
        </>)}
    </section>);
};
export default ReportInsightCard;
